export const css = {
	root: '_2P1-uTkI',
	loading: 'RxKrerFa',
	instructions: '_3nTGgrV1',
	score: '_3hLcn-o8',
	scoreTitle: '_10yAqPCl',
	scorePercent: '_1rjT6yKD',
	actions: '_1QeENSS4',
	oneaction: '_2urRd6pm',
	nextprev: 'eAnUXe4F',
	previous: 'TaTEDEMc',
	next: 'Oe7xzH1Q',
	recommendedReading: '_1lKNl2ZM',
	timerblock: 'ljkJxhSg',
	timer: '_3ob8zHTW',
	primaryButton: '_3jN_E24J',
	actionIcon: 'M2RQCexT',
	microQuizWrapper: 'qvK3lDI-',
	microQuizHeader: '_3_nuAU5e',
	passed_instructions: 'C0hG7M6i',
	' _key': 'quiz-widgets/questionfeedback'
};

export default css;
